import { round } from 'lodash';
import { UNIT_TYPES } from "../../utils/constant";
import { pixelsToUnits, uuid } from "../../utils/helpers";

const RESIZE_HANDLE_SIZE = 8;
const ROTATION_HANDLE_DISTANCE = 30;
const ROTATION_HANDLE_SIZE = 12;
const RESIZE_HANDLE_COLOR = "#ff1e1eff";
const ROTATION_HANDLE_COLOR = "#ff1e1eff";
const SELECTED_ELEMENT_COLOR = "#ff1e1eff";

export const createElement = ({ rackCode, x1, y1, x2, y2, type, objectType, zIndex, ...rest }) => {
  const colorsByObjectType = {
    rack: "#ddccaf",
    wall: "#d8b55b",
    area: "#FFCC33",
    dock: "#c3c3c3",
    zone: "#9eb5de",
  };

  const id = uuid(3);

  let name = `${objectType}_${id}`;

  //if objectType is bin, then add rackCode prefix
  if (objectType === 'bin') {
    name = `${rackCode}_Bin_${id}`;
  }

  const code = name; // using name as code. of course it is editable.
  const unique_id = `temp_${id}`;

  return {
    name,
    code,
    color: colorsByObjectType[objectType] || "white",
    hasElementChanges: false,
    id: unique_id,
    x1,
    y1,
    x2,
    y2,
    type,
    objectType,
    unitType: UNIT_TYPES.inch,
    zIndex,
    orientation: 0,
    rotation: 0, // Add rotation property (in degrees)
    ...rest,
  };
};

const COLOR_OBJECT_TYPES = new Set([
  "wall",
  "rack",
  "area",
  "dock",
  "zone",
  "dock",
]);

const EXCLUDE_TEXT = new Set(["wall", "dock"]);

const getFontSize = (type, w, h) => {
  switch (type) {
    case "rack":
      return (w + h) / 17;
    case "dock":
    case "zone":
      return (w + h) / 12;
    case "area":
    case "dock":
      return (w + h) * 0.05;
    default:
      return 0;
  }
};

const wrapText = (ctx, text, maxWidth) => {
  const words = text.split(" ");
  const lines = [];
  let line = words[0];

  for (let i = 1; i < words.length; i++) {
    const test = line + " " + words[i];
    if (ctx.measureText(test).width <= maxWidth) {
      line = test;
    } else {
      lines.push(line);
      line = words[i];
    }
  }

  lines.push(line);
  return lines;
};

export const drawElement = ({
  element,
  ctx,
  zoom,
  panOffset,
}) => {
  const {
    type,
    objectType,
    rotation = 0,
    x1,
    y1,
    x2,
    y2,
    name,
    color,
  } = element;

  // --- World → Screen ---
  const sx1 = x1 * zoom + panOffset.x;
  const sy1 = y1 * zoom + panOffset.y;
  const sx2 = x2 * zoom + panOffset.x;
  const sy2 = y2 * zoom + panOffset.y;

  if (type === "line") {
    ctx.beginPath();
    ctx.moveTo(sx1, sy1);
    ctx.lineTo(sx2, sy2);
    ctx.stroke();
    return;
  }

  //       x1 = x1 * zoom + panOffset.x;
  //       y1 = y1 * zoom + panOffset.y;
  //       x2 = x2 * zoom + panOffset.x;
  //       y2 = y2 * zoom + panOffset.y;

  //       // Calculate center point for rotation
  //       const centerX = (x1 + x2) / 2;
  //       const centerY = (y1 + y2) / 2;

  // --- Rectangle ---
  const width = sx2 - sx1;
  const height = sy2 - sy1;
  const cx = (sx1 + sx2) / 2;
  const cy = (sy1 + sy2) / 2;

  ctx.save();

  // Rotation (once)
  if (rotation) {
    ctx.translate(cx, cy);
    ctx.rotate((rotation * Math.PI) / 180);
    ctx.translate(-cx, -cy);
  }

  // Color handling
  if (COLOR_OBJECT_TYPES.has(objectType)) {
    ctx.fillStyle = color;
    ctx.strokeStyle = color;
  }

  // --- Wall ---
  if (objectType === "wall") {
    ctx.translate(cx, cy);
    // ctx.rotate(rotation);
    ctx.rotate((element.orientation * Math.PI) / 180);

    ctx.translate(-cx, -cy);

    ctx.beginPath();
    ctx.moveTo(sx1, sy1);
    ctx.lineTo(sx2, sy2);
    ctx.stroke();
    ctx.restore();
    return;
  }

  // --- Rectangle body ---
  ctx.lineWidth = 2;
  ctx.fillRect(sx1, sy1, width, height);

  ctx.strokeStyle = "rgba(0,0,0,0.3)";
  ctx.strokeRect(sx1, sy1, width, height);

  // --- Text ---
  if (name && !EXCLUDE_TEXT.has(objectType)) {
    const fontSize = getFontSize(objectType, width, height);

    if (fontSize > 0) {
      ctx.save();

      ctx.font = `${fontSize}px Arial`;
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const lines = wrapText(ctx, name, width - 20);
      const lineHeight = fontSize * 1.2;
      const startY = cy - ((lines.length - 1) * lineHeight) / 2;

      // Rotate text if needed
      if (ctx.measureText(lines[0]).width > width) {
        ctx.translate(cx, cy);
        ctx.rotate(-Math.PI / 2);
        ctx.translate(-cx, -cy);
      }

      lines.forEach((line, i) => {
        ctx.fillText(line, cx, startY + i * lineHeight);
      });

      ctx.restore();
    }
  }

  ctx.restore();
};



// export const drawElement = ({
//   element, ctx, action, selectedElement, zoom, panOffset
// }) => {
//   const { type, objectType, rotation = 0 } = element;


//   let { x1, y1, x2, y2, name, color } = element;
//   switch (type) {
//     case "line":
//       x1 = x1 * zoom + panOffset.x;
//       y1 = y1 * zoom + panOffset.y;
//       x2 = x2 * zoom + panOffset.x;
//       y2 = y2 * zoom + panOffset.y;
//       // y2 = y1;

//       ctx.beginPath();
//       ctx.moveTo(x1, y1);
//       ctx.lineTo(x2, y2);
//       ctx.stroke();
//       break;
//     case "rectangle":
//       x1 = x1 * zoom + panOffset.x;
//       y1 = y1 * zoom + panOffset.y;
//       x2 = x2 * zoom + panOffset.x;
//       y2 = y2 * zoom + panOffset.y;

//       // Calculate center point for rotation
//       const centerX = (x1 + x2) / 2;
//       const centerY = (y1 + y2) / 2;

//       ctx.save();

//       // Apply rotation if exists
//       if (rotation !== 0) {
//         ctx.translate(centerX, centerY);
//         ctx.rotate((rotation * Math.PI) / 180);
//         ctx.translate(-centerX, -centerY);
//       }

//       const COLOR_OBJECT_TYPES = new Set([
//         "wall",
//         "rack",
//         "area",
//         "dock",
//         "zone",
//         "dockArea",
//       ]);

//       if (COLOR_OBJECT_TYPES.has(objectType)) {
//         ctx.strokeStyle = color;
//         ctx.fillStyle = color;
//       }

//       if (objectType === "wall") {
//         const wallThickness = 5; // fixed thickness in pixels

//         ctx.save();
//         ctx.strokeStyle = color;
//         // ctx.lineWidth = wallThickness;
//         ctx.beginPath();
//         ctx.moveTo(x1, y1);
//         ctx.lineTo(x2, y2);
//         ctx.stroke();
//         ctx.restore();

//         return;
//       } else {
//         ctx.lineWidth = 2;
//         ctx.fillRect(x1, y1, x2 - x1, y2 - y1);
//         ctx.strokeStyle = "rgba(0, 0, 0, 0.3)";
//         ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);
//       }

//       //Exclude the text for wall and dock
//       const excludeTextForObjectType = ["wall", "dock"];

//       if (name && !excludeTextForObjectType.includes(objectType)) {
//         ctx.save(); // Save the current transformation matrix
//         ctx.textAlign = "center";
//         ctx.textBaseline = "middle";
//         const centerX = (x1 + x2) / 2;
//         const centerY = (y1 + y2) / 2;
//         const width = x2 - x1;
//         const height = y2 - y1;

//         let fontSize = 0;
//         if (objectType === "rack") {
//           fontSize = (width + height) / 17;
//         } else if (objectType === "dock" || objectType === "zone") {
//           fontSize = (width + height) / 12;
//         } else if (objectType === "area" || objectType === "dockArea") {
//           fontSize = (width + height) * 0.05;
//         }

//         ctx.font = `${fontSize}px Arial`;

//         // Function to wrap text
//         function wrapText(text, maxWidth) {
//           let words = text.split(" ");
//           let lines = [];
//           let currentLine = words[0];

//           for (let i = 1; i < words.length; i++) {
//             let word = words[i];
//             let width = ctx.measureText(currentLine + " " + word).width;
//             if (width < maxWidth) {
//               currentLine += " " + word;
//             } else {
//               lines.push(currentLine);
//               currentLine = word;
//             }
//           }
//           lines.push(currentLine);
//           return lines;
//         }

//         // Wrap the text
//         let lines = wrapText(name, width - 100); // 10px padding

//         if (x2 - x1 < ctx.measureText(lines[0]).width) {
//           // Rotate text if the width of the rectangle is not enough
//           ctx.translate(centerX, centerY);
//           ctx.rotate(-Math.PI / 2); // Rotate 90 degrees counterclockwise
//           ctx.translate(-centerX, -centerY);
//         }
//         ctx.fillStyle = "black";

//         // Calculate total height of text
//         let lineHeight = fontSize * 1.2;
//         let totalHeight = lineHeight * lines.length;

//         // Adjust starting Y position to center all lines vertically
//         let startY = centerY - totalHeight / 2 + lineHeight / 2;

//         // Draw each line
//         lines.forEach((line, index) => {
//           ctx.fillText(line, centerX, startY + index * lineHeight);
//         });

//         // ctx.fillText(name, centerX, centerY);
//         ctx.restore(); // Restore the transformation matrix for text
//       }

//       ctx.restore(); // Restore the transformation matrix for rotation
//     //   ctx.strokeStyle = "red"; // outline color
//     default:
//   }
//   return;
// };

// Convert screen coordinates to world coordinates
export function screenToWorld({ x, y, pan, zoom }) {
  return {
    x: (x - pan.x) / zoom,
    y: (y - pan.y) / zoom
  };
}

// Convert world coordinates to screen coordinates
export function worldToScreen({ x, y, pan, zoom }) {
  return {
    x: x * zoom + pan.x,
    y: y * zoom + pan.y
  };
}

// without major / minor grid lines
export const drawInfiniteGridWithoutMajorGridLines = ({ canvas, cellSize = 50, ctx, zoom = 1, panOffset, scaledOffset }) => {

  const adjustedCellSize = cellSize * zoom;

  const MAJOR_GRID_LINES = 5;
  // Adjust startX and startY based on panOffset
  const startX = panOffset.x % adjustedCellSize;
  const startY = panOffset.y % adjustedCellSize;

  // Set stroke style
  ctx.strokeStyle = '#ddd';
  ctx.lineWidth = 0.5;

  // Draw horizontal lines
  for (let y = startY; y < canvas.height; y += adjustedCellSize) {
    ctx.lineWidth = y % (adjustedCellSize * MAJOR_GRID_LINES) === 0 ? 2 : 0.5;
    ctx.beginPath();
    ctx.moveTo(0, y);
    ctx.lineTo(canvas.width, y);
    ctx.stroke();
    ctx.closePath();

  }

  // Draw vertical lines
  for (let x = startX; x < canvas.width; x += adjustedCellSize) {
    ctx.lineWidth = x % (adjustedCellSize * MAJOR_GRID_LINES) === 0 ? 2 : 0.5;
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x, canvas.height);
    ctx.stroke();
    ctx.closePath();

  }


  // Draw origin lines
  // Convert world origin (0,0) to screen coordinates
  const origin = worldToScreen({ x: 0, y: 0, pan: panOffset, zoom: zoom });

  // Draw X axis (Y = 0)
  ctx.beginPath();
  ctx.strokeStyle = '#ff0000';
  ctx.lineWidth = 1;
  ctx.moveTo(0, origin.y);
  ctx.lineTo(canvas.width, origin.y);
  ctx.stroke();

  // Draw Y axis (X = 0)
  ctx.beginPath();
  ctx.strokeStyle = '#0000ff';
  ctx.lineWidth = 1;
  ctx.moveTo(origin.x, 0);
  ctx.lineTo(origin.x, canvas.height);
  ctx.stroke();

};

// --- Grid drawing helper ---
function drawLine(ctx, x1, y1, x2, y2, isMajor) {
  ctx.beginPath();
  ctx.strokeStyle = isMajor ? "#ddd" : "#eee";
  ctx.lineWidth = isMajor ? 1.5 : 0.5;
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.stroke();
}

export const drawInfiniteGrid = ({
  canvas,
  ctx,
  cellSize = 50,
  zoom = 1,
  panOffset,
  showXYAxis = true,
}) => {
  const { width, height } = canvas;

  // --- Grid configuration ---
  const scaledCellSize = cellSize * zoom;

  // Major line spacing based on zoom
  const majorLineEvery = zoom >= 2 ? 2 : zoom >= 1 ? 5 : zoom >= 0.5 ? 10 : 50;

  // --- Visible world bounds ---
  const startX = Math.floor((-panOffset.x) / scaledCellSize) * scaledCellSize;
  const startY = Math.floor((-panOffset.y) / scaledCellSize) * scaledCellSize;

  const endX =
    Math.ceil((width - panOffset.x) / scaledCellSize) * scaledCellSize;
  const endY =
    Math.ceil((height - panOffset.y) / scaledCellSize) * scaledCellSize;


  // --- Vertical grid lines ---
  for (let x = startX; x <= endX; x += scaledCellSize) {
    const screenX = x + panOffset.x;
    const index = Math.round(x / scaledCellSize);
    const isMajor = index % majorLineEvery === 0;

    drawLine(ctx, screenX, 0, screenX, height, isMajor);
  }

  // --- Horizontal grid lines ---
  for (let y = startY; y <= endY; y += scaledCellSize) {
    const screenY = y + panOffset.y;
    const index = Math.round(y / scaledCellSize);
    const isMajor = index % majorLineEvery === 0;

    drawLine(ctx, 0, screenY, width, screenY, isMajor);
  }

  // --- Axes ---
  if (!showXYAxis) return;

  const originX = panOffset.x;
  const originY = panOffset.y;

  // X axis
  ctx.beginPath();
  ctx.strokeStyle = "#ff0000";
  ctx.lineWidth = 1.5;
  ctx.moveTo(0, originY);
  ctx.lineTo(width, originY);
  ctx.stroke();

  // Y axis
  ctx.beginPath();
  ctx.strokeStyle = "#0000ff";
  ctx.lineWidth = 1.5;
  ctx.moveTo(originX, 0);
  ctx.lineTo(originX, height);
  ctx.stroke();
};


//Draw Sub Areas
export const createSubAreas = ({ element, rows, columns, areaRows = null, maxCapacity = null }) => {
  let cellLength = (element?.x2 - element?.x1) / columns;
  cellLength = round(cellLength, 2);

  let cellBreath = (element?.y2 - element?.y1) / rows;
  cellBreath = round(cellBreath, 2);

  let _rowStartYPositon = element?.y2 - cellBreath;
  _rowStartYPositon = round(_rowStartYPositon, 2);

  let _rowStartXPositon = element?.x1;
  _rowStartXPositon = round(_rowStartXPositon, 2);

  const _rows = [];

  for (let i = 1; i <= rows; i++) {
    let _row = [];
    // alert('Test Row')
    for (let j = 1; j <= columns; j++) {
      let positionX = element?.x1 + cellLength * (j - 1);
      positionX = round(positionX, 2);
      const subArea = {
        row: i,
        column: j,
        code: areaRows?.[i]?.[j]?.code || `${element?.code}-R${i}-C${j}`,
        positionX: positionX,
        positionY: _rowStartYPositon,
        width: cellLength,
        height: cellBreath,
        x1: positionX,
        y1: _rowStartYPositon,
        x2: positionX + cellLength,
        y2: _rowStartYPositon + cellBreath,
        name: `${element?.name}-R${i}-C${j}`,
        unitType: element?.unitType,
        maxCapacity: maxCapacity || element?.maxCapacity
      };
      _row.push(subArea);
    }
    _rows.push(..._row);
    _row = [];
    _rowStartYPositon = round(_rowStartYPositon - cellBreath);
  }
  return _rows;
}




export const updateSubAreasPositions = (element) => {
  if (!element || !element.subAreas || element.subAreas.length === 0) {
    return element; // Or handle as an error/empty case
  }

  // Step 1: Get unique positionY from subAreas and SORT them.
  // Sorting is crucial to ensure ROW1, ROW2, etc., correspond to visual top-to-bottom order.
  const uniquePositionY = [...new Set(element.subAreas.map(obj => obj.positionY))].sort((a, b) => a - b);

  // Step 2: Create a map from original positionY to ROW labels
  const positionYToRowMap = {};
  uniquePositionY.forEach((pos, index) => {
    positionYToRowMap[pos] = `ROW${index + 1}`;
  });

  // Step 3: Group by original positionY using ROW labels
  const groupedByRow = element.subAreas.reduce((acc, obj) => {
    const rowKey = positionYToRowMap[obj.positionY];
    if (!acc[rowKey]) acc[rowKey] = [];
    acc[rowKey].push(obj);
    return acc;
  }, {});

  // Optional: Sort subAreas within each row by their original positionX.
  // This ensures columns are laid out left-to-right based on their original X order.
  for (const rowKey in groupedByRow) {
    if (groupedByRow.hasOwnProperty(rowKey)) {
      groupedByRow[rowKey].sort((a, b) => a.positionX - b.positionX);
    }
  }

  const newSubAreas = [];
  let currentGlobalY = element.y1; // Start at the top of the parent element

  // Iterate through rows based on the sorted uniquePositionY values
  for (const originalPosY of uniquePositionY) {
    const rowKey = positionYToRowMap[originalPosY];
    const columnsInThisRow = groupedByRow[rowKey];

    if (!columnsInThisRow || columnsInThisRow.length === 0) {
      continue; // Should not happen if originalPosY came from subAreas
    }

    let currentXInRow = element.x1; // Reset X for each new row, starting at parent's x1
    let maxHeightInThisRow = 0;

    // Iterate over each column (subArea) in the current row
    for (let j = 0; j < columnsInThisRow.length; j++) {
      const column = columnsInThisRow[j];

      const subAreaPositionX1 = currentXInRow;
      const subAreaPositionY1 = currentGlobalY; // All items in this row share this top Y
      const subAreaPositionX2 = subAreaPositionX1 + column.width;
      const subAreaPositionY2 = subAreaPositionY1 + column.height; // Each item uses its own height for its bottom

      const subArea = {
        ...column,
        x: subAreaPositionX1,          // Typically top-left X
        y: subAreaPositionY1,          // Typically top-left Y
        positionX: subAreaPositionX1,  // Update with new calculated X
        positionY: subAreaPositionY1,  // Update with new calculated Y
        x1: subAreaPositionX1,
        x2: subAreaPositionX2,
        y1: subAreaPositionY1,
        y2: subAreaPositionY2
      };
      newSubAreas.push(subArea);

      currentXInRow += column.width; // Advance X for the next column in this row

      if (column.height > maxHeightInThisRow) {
        maxHeightInThisRow = column.height; // Track the tallest item in this row
      }
    }
    currentGlobalY += maxHeightInThisRow; // Advance Y for the next row by the height of the row just processed
  }

  return { ...element, subAreas: newSubAreas };
};


export const easeOut = (k) => {
  return 1 - Math.pow(1 - k, 4);
};

const easeOutInterpolate = (from, to, progress) => {
  return (to - from) * easeOut(progress) + from;
};

export const easeToValuesRAF = ({
  fromValues,
  toValues,
  onStep,
  duration = 250,
  interpolateValue,
  onStart,
  onEnd,
  onCancel,
}) => {
  let canceled = false;
  let frameId = 0;
  let startTime;

  function step(timestamp) {
    if (canceled) {
      return;
    }
    if (startTime === undefined) {
      startTime = timestamp;
      onStart?.();
    }

    const elapsed = Math.min(timestamp - startTime, duration);
    const factor = easeOut(elapsed / duration);

    const newValues = {};

    Object.keys(fromValues).forEach((key) => {
      const _key = key;
      const result = ((toValues[_key] - fromValues[_key]) * factor +
        fromValues[_key]);
      newValues[_key] = result;
    });

    onStep(newValues);

    if (elapsed < duration) {
      const progress = elapsed / duration;

      const newValues = {};

      Object.keys(fromValues).forEach((key) => {
        const _key = key;
        const startValue = fromValues[_key];
        const endValue = toValues[_key];

        let result;

        result = interpolateValue
          ? interpolateValue(startValue, endValue, progress, _key)
          : easeOutInterpolate(startValue, endValue, progress);

        if (result == null) {
          result = easeOutInterpolate(startValue, endValue, progress);
        }

        newValues[_key] = result;
      });
      onStep(newValues);

      frameId = window.requestAnimationFrame(step);
    } else {
      onStep(toValues);
      onEnd?.();
    }
  }

  frameId = window.requestAnimationFrame(step);

  return () => {
    onCancel?.();
    canceled = true;
    window.cancelAnimationFrame(frameId);
  };
};


export const throttleRAF = (
  fn,
  opts
) => {
  let timerId = null;
  let lastArgs = null;
  let lastArgsTrailing = null;

  const scheduleFunc = (args) => {
    timerId = window.requestAnimationFrame(() => {
      timerId = null;
      fn(...args);
      lastArgs = null;
      if (lastArgsTrailing) {
        lastArgs = lastArgsTrailing;
        lastArgsTrailing = null;
        scheduleFunc(lastArgs);
      }
    });
  };

  const ret = (...args) => {
    if (import.meta.env.MODE === "test") {
      fn(...args);
      return;
    }
    lastArgs = args;
    if (timerId === null) {
      scheduleFunc(lastArgs);
    } else if (opts?.trailing) {
      lastArgsTrailing = args;
    }
  };
  ret.flush = () => {
    if (timerId !== null) {
      cancelAnimationFrame(timerId);
      timerId = null;
    }
    if (lastArgs) {
      fn(...(lastArgsTrailing || lastArgs));
      lastArgs = lastArgsTrailing = null;
    }
  };
  ret.cancel = () => {
    lastArgs = lastArgsTrailing = null;
    if (timerId !== null) {
      cancelAnimationFrame(timerId);
      timerId = null;
    }
  };
  return ret;
};

export const isElementInSelectionArea = (element, selectionArea) => {

  const elementRect = {
    left: Math.min(element.x1, element.x2),
    right: Math.max(element.x1, element.x2),
    top: Math.min(element.y1, element.y2),
    bottom: Math.max(element.y1, element.y2)
  };

  // Convert selection area from screen space to world space
  const selectionRect = {
    left: (Math.min(selectionArea.x1, selectionArea.x2)),
    right: (Math.max(selectionArea.x1, selectionArea.x2)),
    top: (Math.min(selectionArea.y1, selectionArea.y2)),
    bottom: (Math.max(selectionArea.y1, selectionArea.y2))
  };

  return !(elementRect.left > selectionRect.right ||
    elementRect.right < selectionRect.left ||
    elementRect.top > selectionRect.bottom ||
    elementRect.bottom < selectionRect.top);
};



// Helper to rotate a point around a center.
const rotatePoint = (pointX, pointY, centerX, centerY, angle) => {
  const radians = (angle * Math.PI) / 180;
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  const translatedX = pointX - centerX;
  const translatedY = pointY - centerY;
  return {
    x: translatedX * cos - translatedY * sin + centerX,
    y: translatedX * sin + translatedY * cos + centerY,
  };
};

// Helper to calculate the screen positions of all handles for a given element
const getHandlePositions = (element, zoom, panOffset) => {

  // If it is a wall, return the wall handle positions
  if (element.objectType === "wall") {
    return getWallHandlePositions(element, zoom, panOffset);
  }

  const { x1, y1, x2, y2, rotation = 0 } = element;

  // Transform to screen coordinates for the un-rotated box
  const sx1 = x1 * zoom + panOffset.x;
  const sy1 = y1 * zoom + panOffset.y;
  const sx2 = x2 * zoom + panOffset.x;
  const sy2 = y2 * zoom + panOffset.y;

  const width = sx2 - sx1;
  const height = sy2 - sy1;
  const centerX = sx1 + width / 2;
  const centerY = sy1 + height / 2;

  // Define the 8 resize handle positions for the un-rotated box
  const unrotatedHandles = [
    { x: sx1, y: sy1, position: "tl", cursor: "nwse-resize" },
    { x: centerX, y: sy1, position: "n", cursor: "ns-resize" },
    { x: sx2, y: sy1, position: "tr", cursor: "nesw-resize" },
    { x: sx2, y: centerY, position: "e", cursor: "ew-resize" },
    { x: sx2, y: sy2, position: "br", cursor: "nwse-resize" },
    { x: centerX, y: sy2, position: "s", cursor: "ns-resize" },
    { x: sx1, y: sy2, position: "bl", cursor: "nesw-resize" },
    { x: sx1, y: centerY, position: "w", cursor: "ew-resize" },
  ];

  // Define rotation handle for UN-ROTATED box
  const unrotatedRotationHandle = {
    x: centerX,
    y: sy1 - ROTATION_HANDLE_DISTANCE,
    position: "rotate",
    cursor: "grab",
  };
  const unrotatedTopMiddle = { x: centerX, y: sy1 };

  // Now, rotate all these points around the center
  const resizeHandles = unrotatedHandles.map((h) => ({
    ...h,
    ...rotatePoint(h.x, h.y, centerX, centerY, rotation),
  }));
  const rotationHandle = {
    ...unrotatedRotationHandle,
    ...rotatePoint(unrotatedRotationHandle.x, unrotatedRotationHandle.y, centerX, centerY, rotation),
  };
  const rotationLineStart = rotatePoint(unrotatedTopMiddle.x, unrotatedTopMiddle.y, centerX, centerY, rotation);

  return {
    resizeHandles,
    rotationHandle,
    rotationLine: { start: rotationLineStart, end: rotationHandle },
  };
};

const drawWallSelectionUI = ({ element, ctx, zoom, panOffset }) => {
  const { x1, y1, x2, y2, unitType, rotation } = element;

  const sx1 = x1 * zoom + panOffset.x;
  const sy1 = y1 * zoom + panOffset.y;
  const sx2 = x2 * zoom + panOffset.x;
  const sy2 = y2 * zoom + panOffset.y;

  const midX = (sx1 + sx2) / 2;
  const midY = (sy1 + sy2) / 2;

  const dx = sx2 - sx1;
  const dy = sy2 - sy1;
  const length = Math.hypot(dx, dy);
  if (length === 0) return;

  const angle = Math.atan2(dy, dx) + element.rotation / 180 * Math.PI;

  // --- Rotate context to wall orientation ---
  ctx.save();
  ctx.translate(midX, midY);
  // ctx.rotate(angle);
  // ctx.rotate((rotation * Math.PI) / 180);


  // ===== Selection line =====
  ctx.strokeStyle = SELECTED_ELEMENT_COLOR;
  ctx.lineWidth = 2;
  // ctx.beginPath();
  // ctx.moveTo(-length / 2, 0);
  // ctx.lineTo(length / 2, 0);
  // ctx.stroke();

  // ctx.translate(midX, midY);
  // ctx.rotate(rotation);
  // ctx.rotate((element.orientation * Math.PI) / 180);

  ctx.translate(-midX, -midY);

  ctx.beginPath();
  ctx.moveTo(sx1, sy1);
  ctx.lineTo(sx2, sy2);
  ctx.stroke();
  ctx.restore();

  // ===== Endpoint handles =====
  // const half = length / 2;
  // [-half, half].forEach((x) => {
  //   ctx.beginPath();
  //   ctx.fillStyle = "#ff1e1eff";
  //   ctx.rect(
  //     x - RESIZE_HANDLE_SIZE / 2,
  //     -RESIZE_HANDLE_SIZE / 2,
  //     RESIZE_HANDLE_SIZE,
  //     RESIZE_HANDLE_SIZE
  //   );
  //   ctx.fill();
  // });
  const wx1 = sx1;
  const wy1 = sy1;
  const wx2 = sx2;
  const wy2 = sy2;

  const wallHandles = [
    { x: wx1, y: wy1, position: "start" },
    { x: wx2, y: wy2, position: "end" }
  ];

  // Draw endpoint resize handles
  wallHandles.forEach((handle) => {
    ctx.beginPath();
    ctx.fillStyle = RESIZE_HANDLE_COLOR;
    ctx.strokeStyle = RESIZE_HANDLE_COLOR;
    ctx.lineWidth = 1;
    ctx.rect(
      handle.x - RESIZE_HANDLE_SIZE / 2,
      handle.y - RESIZE_HANDLE_SIZE / 2,
      RESIZE_HANDLE_SIZE,
      RESIZE_HANDLE_SIZE
    );
    ctx.fill();
    ctx.stroke();
  });

  const dwx = wx2 - wx1, dwy = wy2 - wy1;
  const len = Math.hypot(dwx, dwy);

  // Perpendicular unit vector
  let perpX = -dwy / len;
  let perpY = dwx / len;

  // Flip perpendicular vector if it points downward (to place handle "above")
  if (perpY < 0) {
    perpX = -perpX;
    perpY = -perpY;
  }

  // ===== Center handle =====
  ctx.beginPath();
  ctx.fillStyle = ROTATION_HANDLE_COLOR;
  ctx.strokeStyle = ROTATION_HANDLE_COLOR;
  ctx.rect(wx1 + dwx / 2 - RESIZE_HANDLE_SIZE / 2, wy1 + dwy / 2 - RESIZE_HANDLE_SIZE / 2, RESIZE_HANDLE_SIZE, RESIZE_HANDLE_SIZE);
  ctx.fill();
  ctx.stroke();

  // ===== Length label =====
  const lengthUnits = pixelsToUnits(length, unitType);

  ctx.font = "14px Arial";
  ctx.fillStyle = "#333";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(`${round(lengthUnits, 2)} ${unitType}`, wx1 + dwx / 2 + perpX * 12, wy1 + dwy / 2 + perpY * 12);

  ctx.restore();
};


/**
 * Draws selection UI with resize handles and rotation handle
 */
export const drawSelectionUI = ({ element, ctx, zoom, panOffset }) => {
  const { x1, y1, x2, y2, rotation = 0, objectType, unitType } = element;

  if (element.objectType === "wall" && element.type === "line") {
    drawWallSelectionUI({ element, ctx, zoom, panOffset });
    return;
  }


  // Transform coordinates based on zoom and pan
  const sx1 = x1 * zoom + panOffset.x;
  const sy1 = y1 * zoom + panOffset.y;
  const sx2 = x2 * zoom + panOffset.x;
  const sy2 = y2 * zoom + panOffset.y;

  // Calculate center point of the element in canvas space for rotation
  const centerX = (sx1 + sx2) / 2;
  const centerY = (sy1 + sy2) / 2;

  // ========== Draw Selection Outline ==========
  ctx.save();
  // Apply rotation for drawing selection outline
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);

  // Draw selection outline
  ctx.strokeStyle = SELECTED_ELEMENT_COLOR;
  ctx.lineWidth = 2;
  ctx.setLineDash([]);

  if (objectType === "wall") {
    // Wall is drawn as a line between two points
    ctx.beginPath();
    ctx.moveTo(sx1, sy1);
    ctx.lineTo(sx2, sy2);
    ctx.stroke();
  } else {
    // ctx.strokeRect(sx1 - padding, sy1 - padding, sx2 - sx1 + padding * 2, sy2 - sy1 + padding * 2);
    ctx.strokeRect(sx1, sy1, sx2 - sx1, sy2 - sy1);
  }
  ctx.restore(); // Restore from rotation
  ctx.setLineDash([]);

  // ========== Draw Handles ==========

  // Get handle positions and draw them
  if (objectType !== "wall") {
    const { resizeHandles, rotationHandle, rotationLine } = getHandlePositions(element, zoom, panOffset);

    // Draw resize handles
    resizeHandles.forEach((handle) => {
      ctx.beginPath();
      ctx.fillStyle = RESIZE_HANDLE_COLOR;
      ctx.strokeStyle = RESIZE_HANDLE_COLOR;
      ctx.lineWidth = 1;
      ctx.rect(handle.x - RESIZE_HANDLE_SIZE / 2, handle.y - RESIZE_HANDLE_SIZE / 2, RESIZE_HANDLE_SIZE, RESIZE_HANDLE_SIZE);
      ctx.fill();
      ctx.stroke();
    });

    // Draw line to rotation handle
    ctx.beginPath();
    ctx.strokeStyle = ROTATION_HANDLE_COLOR;
    ctx.lineWidth = 2;
    ctx.moveTo(rotationLine.start.x, rotationLine.start.y);
    ctx.lineTo(rotationLine.end.x, rotationLine.end.y);
    ctx.stroke();

    // Draw rotation handle circle
    const rotationHandleSize = RESIZE_HANDLE_SIZE * 1.2;
    ctx.beginPath();
    ctx.fillStyle = ROTATION_HANDLE_COLOR;
    ctx.strokeStyle = ROTATION_HANDLE_COLOR;
    ctx.lineWidth = 2;
    ctx.arc(rotationHandle.x, rotationHandle.y, rotationHandleSize / 2, 0, 2 * Math.PI);
    ctx.fill();
    ctx.stroke();
  }

  // if object type is wall, then add resize handles only on the top and bottom of the wall, and a rotation handle in the middle of the wall
  if (element.objectType === "wall") {
    // Calculate endpoints of the wall in canvas/display space
    const x1 = element.x1 * zoom + panOffset.x;
    const y1 = element.y1 * zoom + panOffset.y;
    const x2 = element.x2 * zoom + panOffset.x;
    const y2 = element.y2 * zoom + panOffset.y;

    const wallHandles = [
      { x: x1, y: y1, position: "start" },
      { x: x2, y: y2, position: "end" }
    ];

    // Draw endpoint resize handles
    wallHandles.forEach((handle) => {
      ctx.beginPath();
      ctx.fillStyle = RESIZE_HANDLE_COLOR;
      ctx.strokeStyle = RESIZE_HANDLE_COLOR;
      ctx.lineWidth = 1;
      ctx.rect(
        handle.x - RESIZE_HANDLE_SIZE / 2,
        handle.y - RESIZE_HANDLE_SIZE / 2,
        RESIZE_HANDLE_SIZE,
        RESIZE_HANDLE_SIZE
      );
      ctx.fill();
      ctx.stroke();
    });

    // Draw central rotation handle and connector line (midpoint of line)
    const midX = (x1 + x2) / 2;
    const midY = (y1 + y2) / 2;
    const rotationHandleDistance = 40; // distance perpendicular from center
    const dx = x2 - x1, dy = y2 - y1;
    const len = Math.hypot(dx, dy);

    // Perpendicular unit vector
    let perpX = -dy / len;
    let perpY = dx / len;

    // Flip perpendicular vector if it points downward (to place handle "above")
    if (perpY < 0) {
      perpX = -perpX;
      perpY = -perpY;
    }
    // const rotHandleX = midX + perpX * rotationHandleDistance;
    // const rotHandleY = midY + perpY * rotationHandleDistance;

    // // Draw line from mid to rotation handle
    // ctx.beginPath();
    // ctx.strokeStyle = "#ff1e1eff";
    // ctx.lineWidth = 2;
    // ctx.moveTo(midX, midY);
    // ctx.lineTo(rotHandleX, rotHandleY);
    // ctx.stroke();

    // // Draw rotation handle itself
    // const rotationHandleSize = RESIZE_HANDLE_SIZE * 1.2;
    // ctx.beginPath();
    // ctx.fillStyle = "#ffffff";
    // ctx.strokeStyle = "#ff1e1eff";
    // ctx.lineWidth = 2;
    // ctx.arc(rotHandleX, rotHandleY, rotationHandleSize / 2, 0, 2 * Math.PI);
    // ctx.fill();
    // ctx.stroke();
  }

  if (element.objectType === 'wall') {
    const x1 = element.x1 * zoom + panOffset.x;
    const y1 = element.y1 * zoom + panOffset.y;
    const x2 = element.x2 * zoom + panOffset.x;
    const y2 = element.y2 * zoom + panOffset.y;

    // Calculate length in the current units
    const length_px = Math.hypot(x2 - x1, y2 - y1);
    // If you have a pixelsToUnits function, use it:
    const length_units = pixelsToUnits(length_px, element.unitType);
    const lengthText = `${round(length_units, 2)} ${element.unitType}`;

    // Midpoint of the wall (for label position)
    const midX = (x1 + x2) / 2;
    const midY = (y1 + y2) / 2;

    // Angle of the wall
    const angleRad = Math.atan2(y2 - y1, x2 - x1);

    ctx.save();
    ctx.font = `14px Arial`;
    ctx.fillStyle = "#333";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle"; // ensures true centering
    // Rotate context for aligned text
    ctx.translate(midX, midY);
    ctx.rotate(angleRad);
    ctx.fillText(lengthText, 0, -18); // Slightly offset above wall
    ctx.restore();

    // Optionally, show rotation angle at the mid point as well
    // (skip this if not required, or add at a fixed offset)
    ctx.save();
    ctx.font = `12px Arial`;
    ctx.fillStyle = "#666";
    ctx.textAlign = "center";
    ctx.translate(midX, midY);
    ctx.rotate(angleRad);
    ctx.fillText(`${round(angleRad * 180 / Math.PI, 1)}°`, 0, -32); // Slightly offset below wall
    ctx.restore();

    // Show rotation angle if object is rotated
    if (rotation && rotation !== 0) {
      const { rotationLine } = getHandlePositions(element, zoom, panOffset);
      ctx.fillStyle = "#333";
      ctx.fillText(`${round(rotation, 1)}°`, rotationLine.end.x, rotationLine.end.y - 20);
    }

    return; // Done—don’t fall through to rectangle logic
  }

  // Draw dimensions
  ctx.save();
  const width = Math.abs(x2 - x1);
  const height = Math.abs(y2 - y1);
  const dimensionPadding = 20;

  ctx.font = `14px Arial`;
  ctx.fillStyle = "#333";
  ctx.textAlign = "center";

  // Position dimensions outside the rotated box
  const { resizeHandles } = getHandlePositions(element, zoom, panOffset);
  const bottomMiddle = resizeHandles.find((h) => h.position === "s");
  const rightMiddle = resizeHandles.find((h) => h.position === "e");

  if (bottomMiddle && rightMiddle) {
    // Width dimension
    const widthText = `${round(pixelsToUnits(width, element.unitType), 2)} ${element.unitType}`;
    ctx.fillText(widthText, bottomMiddle.x, bottomMiddle.y + dimensionPadding);

    // Height dimension
    const heightText = `${round(pixelsToUnits(height, element.unitType), 2)} ${element.unitType}`;
    ctx.save();
    ctx.translate(rightMiddle.x, rightMiddle.y);
    ctx.rotate((rotation * Math.PI) / 180);
    ctx.fillText(heightText, dimensionPadding, 0);
    ctx.restore();
  }
  ctx.restore();



  // Show rotation angle if object is rotated
  if (rotation && rotation !== 0) {
    const { rotationLine } = getHandlePositions(element, zoom, panOffset);
    ctx.fillStyle = "#333";
    ctx.fillText(`${round(rotation, 1)}°`, rotationLine.end.x, rotationLine.end.y - 20);
  }

};

const getWallHandlePositions = (element, zoom, panOffset) => {
  const { x1, y1, x2, y2, rotation = 0 } = element;

  // Screen space
  const sx1 = x1 * zoom + panOffset.x;
  const sy1 = y1 * zoom + panOffset.y;
  const sx2 = x2 * zoom + panOffset.x;
  const sy2 = y2 * zoom + panOffset.y;

  const midX = (sx1 + sx2) / 2;
  const midY = (sy1 + sy2) / 2;

  const dx = sx2 - sx1;
  const dy = sy2 - sy1;
  const length = Math.hypot(dx, dy);
  if (length === 0) return null;

  // Wall angle (geometry + optional extra rotation)
  const baseAngle = Math.atan2(dy, dx);
  const angle = baseAngle + (rotation * Math.PI) / 180;

  // Perpendicular direction
  let perpX = -Math.sin(angle);
  let perpY = Math.cos(angle);

  // Keep rotation handle consistently "above"
  if (perpY < 0) {
    perpX = -perpX;
    perpY = -perpY;
  }

  const rotationOffset = 40;

  const rotationHandle = {
    x: midX + perpX * rotationOffset,
    y: midY + perpY * rotationOffset,
    position: "rotate",
    cursor: "grab",
  };

  return {
    resizeHandles: [
      {
        x: sx1,
        y: sy1,
        position: "start",
        cursor: "ew-resize",
      },
      {
        x: sx2,
        y: sy2,
        position: "end",
        cursor: "ew-resize",
      },
    ],
    rotationHandle,
    rotationLine: {
      start: { x: midX, y: midY },
      end: rotationHandle,
    },
    angle, // extremely useful for hit-testing & dragging
  };
};


// Helper to get resize handle at position
// export const getResizeHandleAtPosition = (x, y, element, zoom, panOffset) => {
//   const { resizeHandles, rotationHandle } = getHandlePositions(element, zoom, panOffset);
//   const handleHitArea = RESIZE_HANDLE_SIZE * 1.5; // Make hit area a bit larger

//   if (element.objectType === "wall") {
//     return getWallHandlePositions(element, zoom, panOffset);
//   }

//   // Filter handles for walls to only endpoint handles ('n' and 's')
//   const handlesToCheck = element.objectType === 'wall'
//     ? resizeHandles.filter(handle => handle.position === 'n' || handle.position === 's' || handle.position === 'tl' || handle.position === 'tr')
//     : resizeHandles;

//   // Check rotation handle first
//   const dx_rot = x - rotationHandle.x;
//   const dy_rot = y - rotationHandle.y;
//   if (dx_rot * dx_rot + dy_rot * dy_rot <= (handleHitArea / 2) * (handleHitArea / 2)) {
//     return rotationHandle;
//   }

//   // Check resize handles
//   for (const handle of handlesToCheck) {
//     if (Math.abs(x - handle.x) <= handleHitArea / 2 && Math.abs(y - handle.y) <= handleHitArea / 2) {
//       return handle;
//     }
//   }

//   return null;
// };
export const getResizeHandleAtPosition = (
  x,
  y,
  element,
  zoom,
  panOffset
) => {
  const handles = getHandlePositions(element, zoom, panOffset);
  if (!handles) return null;

  const { resizeHandles, rotationHandle } = handles;
  const hitSize = RESIZE_HANDLE_SIZE * 1.5;
  const half = hitSize / 2;

  // 1️⃣ Rotation handle (circle hit test)
  if (rotationHandle) {
    const dx = x - rotationHandle.x;
    const dy = y - rotationHandle.y;
    if (dx * dx + dy * dy <= half * half) {
      return rotationHandle;
    }
  }

  // 2️⃣ Resize handles (square hit test)
  if (resizeHandles) {
    for (const handle of resizeHandles) {
      if (
        Math.abs(x - handle.x) <= half &&
        Math.abs(y - handle.y) <= half
      ) {
        return handle;
      }
    }
  }

  return null;
};


// Helper function to calculate rotation angle
export const calculateRotationAngle = (centerX, centerY, mouseX, mouseY) => {
  const deltaX = mouseX - centerX;
  const deltaY = mouseY - centerY;
  // We add 90 degrees because the 0-degree angle in atan2 is along the positive X-axis,
  // but we want our "0" to be pointing upwards (negative Y-axis).
  let angle = Math.round(Math.atan2(deltaY, deltaX) * (180 / Math.PI) + 90);
  // Normalize angle to 0-360 degrees
  if (angle < 0) angle += 360;
  return angle;
};